import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'layout-fab-sub-tools',
    templateUrl: './layout-fab-sub-tools.component.html',
    styleUrls: ['./layout-fab-sub-tools.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LayoutFabSubToolsComponent {
    // data members

    @Input()
    isOpen = false;

    @Input()
    actionIcon?: string;

    @Input()
    estensaIcon?: string;

    @Input()
    tooltip: any;

    @Input()
    enableEstensaFontSet: boolean = true;

    @Input()
    smallFontEnabled: boolean = false;

    private _isMouseOver = false;
    get isMouseOver() {
        return this._isMouseOver;
    }

    @Output()
    actionClick: EventEmitter<any> = new EventEmitter<any>();

    // public functions

    onActionClick(event: any) {
        this.actionClick.emit(event);
    }

    onActionMouseEnter(_: MouseEvent) {
        this.isOpen = true;
    }

    onActionMouseLeave(_: MouseEvent) {
        if (!this.isMouseOver) {
            this.isOpen = false;
        }
    }

    onMouseEnter(_: MouseEvent) {
        this._isMouseOver = true;
        this.isOpen = true;
    }

    onMouseLeave(_: MouseEvent) {
        this._isMouseOver = false;
        this.isOpen = false;
    }
}
